export const SITE_NAME = 'Fae Forest';
export const SITE_ORIGIN =
  import.meta.env.VITE_SITE_ORIGIN ?? 'https://www.faeforest.com.au';
export const SITE_DESCRIPTION =
  'Hand-painted fairy doors, garden creatures, and magical miniatures for your fairy garden.';
export const SITE_EMAIL = 'info@faeforest.com.au';
export const DEFAULT_OG_IMAGE = '/og-image.jpg';
